import React from 'react'
import createReactClass from 'create-react-class'
import styled from 'styled-components'

import i18n from 'live/services/i18n'
import ExtensionUi from 'live/components/extensions/ui/base'
import StoreBasedMixinFactory from 'live/components/mixins/store-based'
import ObjectInitializerFactory from 'live/components/forms/mixins/object-initializer'

import { FormEnabledContext } from 'live/context/form-enabled'

import CollectionsTable, { Collection, Index } from './components/collections-table'
import ModalCreateIndex, { MappingCollectionType } from './components/create-index-modal'
import CollectionsFilter, { CollectionFilterEnum } from './components/collections-filter'
import { ErrorMessagesAlert } from '../components/error-alert'

import ActionsFactory from '../../lib/db-management/actions'
import StoreFactory from '../../lib/db-management/store'
import SearchFactory from 'live/components/lists/ui/search'

const Actions = ActionsFactory('plugin-mongodb/db-management')
const Store = StoreFactory('plugin-mongodb/db-management', Actions)
const StoreBasedMixin = StoreBasedMixinFactory(Store)

const ObjectInitializerMixin = ObjectInitializerFactory('/rest/extension')
const Search = SearchFactory(Actions, {
    preventClearOnEsc: false
})

type ConfigProps = {
    addresses: string[]
    asyncCount: boolean
    authenticationDatabase: string
    dbName: string
    enableForQuery: boolean
    enableForStorage: boolean
    ensureIndexes: boolean
    ensureSharding: boolean
    filter: string
    nonIndexable: boolean
    password: string
    readOnly: boolean
    readPreference: string
    replicaSet: boolean
    ssl: boolean
    useSnappyCompressor: boolean
    useZlibCompressor: boolean
    username: string
    writeConcern: string
    writeConcernParameters: any
}

type StatusProps = {
    valid: boolean
    messages: string[]
    metrics: any
    status: 'VALID' | 'VALID_BUT' | 'INVALID'
}

type ObjectProps = {
    id: string
    active?: boolean
    type?: 'mongodb'
    url?: string
    qualifier?: string
    fullQualifier?: string
    details?: string
    description?: string
    dateCreated?: number
    dateModified?: number
    lastModificationAuthor?: {
        id: number
        name: string
    }
    author?: {
        id: number
        name: string
    }
    additional?: ['STORAGE', 'QUERY'] | ['STORAGE'] | ['QUERY'] | []
    status?: StatusProps
    config?: ConfigProps
}

type CollectionsState = {
    loadingCollections: boolean
    hideTrivial: boolean
    selectedFilter: CollectionFilterEnum
    collectionsNames: MappingCollectionType[]
    collectionsStats: Collection[]
    httpFailure: string | null
    httpDetailedError: string | null
    commandFailure: string | null
    object: ObjectProps
    showCreateIndexModal: boolean
    searchText: string
}

const Collections = createReactClass({
    mixins: [StoreBasedMixin, ObjectInitializerMixin],
    getInitialState() {
        return {
            showCreateIndexModal: false,
            searchText: ''
        }
    },
    onSearch(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ searchText: event.target.value.toLowerCase() })
    },
    clearSearch() {
        this.setState({ searchText: '' })
    },
    toggleCreateModalA() {
        const showCreateIndexModal = !(this.state as CollectionsState).showCreateIndexModal
        this.setState({ showCreateIndexModal })
    },
    toggleIndexCollection(filter: CollectionFilterEnum) {
        const qualifier = (this.state as CollectionsState).object.qualifier
        Actions.filterCollections(qualifier, filter)
    },
    hideTrivial() {
        const qualifier = (this.state as CollectionsState).object.qualifier
        Actions.filterDefaultIndexes(qualifier)
    },
    saveIndexes(selectedCollections: string[], index: Index) {
        const qualifier = (this.state as CollectionsState).object.qualifier
        Actions.createIndex(qualifier, selectedCollections, index)
    },
    clearError() {
        const currentState = { ...this.state }
        if (currentState.object?.status?.messages) {
            currentState.object.status.messages = null
        }
        currentState.httpFailure = null
        currentState.httpDetailedError = null
        currentState.commandFailure = null

        this.setState(currentState)
    },
    _onAfterFetch() {
        const instance = (this.state as CollectionsState).object

        const qualifier = instance.qualifier

        Actions.getAllCollectionsMappingNames(qualifier)
        Actions.getAllCollectionsStats(qualifier)
    },

    render() {
        const state: CollectionsState = this.state
        const loading = state.loadingCollections
        const instance = state.object
        const lastElementStatusMessage = instance?.status?.messages ? instance.status.messages[0] : null
        const config = instance.config
        const qualifier = instance.qualifier

        const hideTrivial = state.hideTrivial
        const selectedFilter = state.selectedFilter
        const searchText = state.searchText
        const collectionsMappingNames = state.collectionsNames
        const collectionsStats = state.collectionsStats

        const httpFailure = state.httpFailure
        const httpDetailedError = state.httpDetailedError
        const collectionsError = (httpFailure && httpFailure !== '') || lastElementStatusMessage
        const commandFailure = state.commandFailure

        const dbname = config && config.dbName ? config.dbName : ''

        const addresses = config && config.addresses ? config.addresses.join(', ') : ''

        const headerSubtitle = `${i18n('Database')}: ${dbname} | ${i18n('Addresses')}: ${addresses}`
        const readonly = this.context.readonly

        return (
            <ExtensionUi
                className="db-management--mongodb"
                {...this.props}
                {...{
                    instance
                }}
                uiCfg={{ headerSubtitle }}
                noFetch={true}
            >
                {state.showCreateIndexModal && (
                    <ModalCreateIndex
                        show={state.showCreateIndexModal}
                        onHide={this.toggleCreateModalA}
                        collections={collectionsMappingNames}
                        saveIndex={(selectedCollections: string[], index: Index) =>
                            this.saveIndexes(selectedCollections, index)
                        }
                    />
                )}
                <div className="db-management-header">
                    {!readonly && (
                        <a className="btn btn-primary btn-bold" onClick={this.toggleCreateModalA}>
                            <i className="fa fa-plus-circle fa-fw" /> {i18n('Create Index')}
                        </a>
                    )}

                    <ActionsContainer>
                        <SearchContainer>
                            <Search
                                state={state.searchText}
                                placeholder={i18n('Search by collections or event types...')}
                                onChange={this.onSearch}
                                onClear={this.clearSearch}
                                refs="search"
                                className="search-field"
                            />
                        </SearchContainer>
                        <CollectionsFilter
                            currentFilter={selectedFilter}
                            onChangeFilter={this.toggleIndexCollection}
                            hideDefaultIndex={hideTrivial}
                            onChangeHideDefaultIndex={this.hideTrivial}
                        />
                    </ActionsContainer>
                </div>

                <div className="db-management-body">
                    {collectionsError && (
                        <ErrorMessagesAlert
                            title={commandFailure}
                            httpFailure={httpFailure}
                            serverSideErrorMessage={httpDetailedError || lastElementStatusMessage}
                            invalidElement={!!lastElementStatusMessage}
                            onClose={this.clearError}
                        />
                    )}

                    <CollectionsTable
                        decrementHeight={collectionsError ? 64 : 0}
                        collections={collectionsStats}
                        collectionsNames={collectionsMappingNames}
                        hideTrivial={hideTrivial}
                        searchText={searchText}
                        selectedFilter={selectedFilter}
                        loading={loading}
                        readonly={readonly}
                        saveIndex={(selectedCollections, index) => this.saveIndexes(selectedCollections, index)}
                        deleteTable={collectionName =>
                            Actions.deleteCollection.bind(Actions, qualifier, collectionName)
                        }
                        deleteIndex={selectedIndex => Actions.deleteIndex.bind(Actions, qualifier, selectedIndex)}
                    />
                </div>
            </ExtensionUi>
        )
    }
})
Collections.contextType = FormEnabledContext

export default Collections

const ActionsContainer = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 300px;
`

const SearchContainer = styled.div`
    input[type='text'] {
        align-items: center;
        height: 36px;
        width: 250px;
        border-radius: 3px;
        border: 1px solid var(--gray-darker-bg);
    }

    span.btn-clean-search {
        top: 23px !important;
        right: 50px !important;
    }
`
